import { defineMessages } from 'react-intl';

export const holdingNoteTypesMessages = defineMessages({
  'action note': {
    id: 'holdingNoteTypes.actionNote',
    defaultMessage: '<b>Action note:</b> {note}',
  },
  binding: {
    id: 'holdingNoteTypes.binding',
    defaultMessage: '<b>Binding:</b> {note}',
  },
  'copy note': {
    id: 'holdingNoteTypes.copyNote',
    defaultMessage: '<b>Copy note:</b> {note}',
  },
  'electronic bookplate': {
    id: 'holdingNoteTypes.electronicBookplate',
    defaultMessage: '<b>Electronic bookplate:</b> {note}',
  },
  note: { id: 'holdingNoteTypes.note', defaultMessage: '<b>Note:</b> {note}' },
  provenance: {
    id: 'holdingNoteTypes.provenance',
    defaultMessage: '<b>Provenance:</b> {note}',
  },
  reproduction: {
    id: 'holdingNoteTypes.reproduction',
    defaultMessage: '<b>Reproduction:</b> {note}',
  },
});
